import React from "react";
import { useMedia } from "../ResponsiveMedia";

import styles from "./Button.module.scss";

const Button = React.forwardRef(
  (
    {
      children = null,
      disabled: isDisabled,
      onClick,
      primary: isPrimary,
      onMouseLeave = null,
      onMouseEnter = null,
      type = "button",
      isInvisible = false,
      isRestricted = false,
      ...rest
    },
    ref
  ) => {
    const width = useMedia(rest.width);

    return !isInvisible && !isRestricted ? (
      <button
        disabled={isDisabled}
        className={`${styles.base} ${isPrimary ? styles.primary : ""} ${
          rest.className ? rest.className : ""
        }`}
        onClick={onClick}
        ref={ref}
        style={{ width }}
        type={type}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </button>
    ) : null;
  }
);

export default Button;
